export const SHARE_LINK_TARGET_LIST_HEIGHT = '250px';

const PLACEHOLDER_ROW_WIDTHS = ['col-7', 'col-5', 'col-8', 'col-4', 'col-6'];

export function ShareLinkTargetListLoadingPlaceholder() {
  return (
    <div className="list-group list-group-flush" style={{ height: SHARE_LINK_TARGET_LIST_HEIGHT }}>
      {PLACEHOLDER_ROW_WIDTHS.map((width, index) => (
        <div key={index} className="placeholder-glow list-group-item px-0 bg-transparent">
          <div className={`placeholder ${width}`}></div>
        </div>
      ))}
    </div>
  );
}
